import { widgetConfig } from "../config";

export const CHANNEL = "fts-lead-widget";

type OutboundMessage =
  | { channel: string; type: "resize"; height: number }
  | { channel: string; type: "success"; link: string }
  | { channel: string; type: "error"; message: string };

export const isEmbedded = (): boolean =>
  typeof window !== "undefined" &&
  window.parent != null &&
  window.parent !== window;

const post = (message: OutboundMessage) => {
  if (isEmbedded()) {
    window.parent.postMessage(message, widgetConfig.parentOrigin || "*");
  }
};

/** Tell the host to size the iframe to the widget's content height. */
export const notifyResize = (height: number) =>
  post({ channel: CHANNEL, type: "resize", height });

/** Tell the host a lead succeeded — it redirects the top window to `link`. */
export const notifySuccess = (link: string) =>
  post({ channel: CHANNEL, type: "success", link });

/** Tell the host a lead failed (optional host-side handling). */
export const notifyError = (message: string) =>
  post({ channel: CHANNEL, type: "error", message });
